import { StateView } from '@amore/ui/components/state-view'
import type { ReactNode } from 'react'

/**
 * Nothing here yet. Offer only actions that make sense now: never counts or
 * links to things that can't exist yet (no "Zkontrolovat odpovědi (2)" before
 * there are guests). Viewers get the description and no actions.
 */
export function EmptyState({
  icon,
  title,
  description,
  actions,
  placement = 'panel',
}: {
  icon: ReactNode
  title: string
  description: ReactNode
  actions?: ReactNode
  placement?: 'panel' | 'inline'
}) {
  return (
    <StateView
      state="empty"
      placement={placement}
      icon={icon}
      heading={title}
      description={description}
      actions={actions}
      className={placement === 'panel' ? 'min-h-72' : undefined}
    />
  )
}
